<div class="alert alert-warning d-flex align-items-center p-2" role="alert">
  <span class="mts-icon notranslate mx-2"  translate="no">warning</span>
  <div class="fs-verysmall">
    {{  message }}
    @if (linkText) {
      <app-link (click)="selected($event)" [title]="linkText" [style]="'alert'" [noPadding]="true">{{ linkText }}</app-link>
    }
  </div>
</div>
